import profile from '@/api/product/profile'
import { mapKeys, camelCase } from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

class SerialPagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  branches: [],
  productTypes: [],
  productCategories: [],
  uomCategories: [],
  productMode: [],
  vendors: [],
  productRecipe: [],
  groups: [],
  serialStatus: [],
  serialResources: [],
  serialPagination: new SerialPagination()
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES_SERIAL(state, { data, meta }) {
    state.serialResources = []
    data.forEach(resource => {
      state.serialResources.push(Object.assign(resource, { _deleting: false }))
    })

    state.serialPagination = new SerialPagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
  SET_BRANCH(state, data){
    state.branches = data
  },
  SET_PRODUCT_MODE(state, data){
    state.productMode = data
  },
  SET_PRDUCT_TYPE(state, data){
    state.productTypes = data
  },
  SET_PRODUCT_CATEGORY(state, data){
    state.productCategories = data
  },
  SET_UOM_CATEGORY(state, data){
    state.uomCategories = data
  },
  SET_VENDOR_LIST(state, data){
    state.vendors = data
  },
  SET_RECIPE_LIST(state, data){
    state.productRecipe = data
  },
  SET_GROUP_LIST(state, data){
    state.groups = data
  },
  RESET_RESOURCES_SERIAL(state){
    state.serialResources = []
  },
  SET_SERIAL_STATUS(state, data){
    state.serialStatus = data
  },
  SET_RESET_SERIAL_PAGE(state, data){
    state.serialPagination = new SerialPagination()
  },
  CLEAR_SETUP(state){
    state.branches = []
    state.productTypes = []
    state.productCategories = []
    state.uomCategories = []
    state.productMode = []
    state.vendors = []
    state.productRecipe = []
    state.groups = []
    state.serialStatus = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return profile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return profile.store(data)
  },
  update(context, { id, data }) {
    return profile.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await profile.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  fetchSerial(context, {id, attrubutes = {}}) {
    let params = Object.assign(
      {
        page: context.state.serialPagination.page,
        perPage: context.state.serialPagination.perPage,
      },
      attrubutes
    )
    return profile.getSerial(id, { params })
    .then(response => {
      context.commit('RECEIVE_RESOURCES_SERIAL', response)
      return Promise.resolve(response)
    })
  },
  fetchAllSerial(context, attrubutes = {}) {
    let params = Object.assign({},
      {
        page: context.state.serialPagination.page,
        perPage: context.state.serialPagination.perPage,
      },
      attrubutes
    )
    return profile.getAllSerial({ params })
    .then(response => {
      context.commit('RECEIVE_RESOURCES_SERIAL', response)
      return Promise.resolve(response)
    })
  },
  destroy(context, id){
    return profile.destroy(id)
  },
  fetchSerialHistory(context, serialNo){
    return profile.getSerialHistory(serialNo)
  },
  async fetchBefore(context){
    let branch = await profile.branch()
      context.commit('SET_BRANCH',branch.data)
    let mode = await profile.mode()
      context.commit('SET_PRODUCT_MODE', mode.data)
    let type = await profile.type()
      context.commit('SET_PRDUCT_TYPE', type.data)
    let category = await profile.category()
      context.commit('SET_PRODUCT_CATEGORY', category.data)
    let uom_category = await profile.uomCategory()
      context.commit('SET_UOM_CATEGORY', uom_category.data)
    let supplier = await profile.supplier()
      context.commit('SET_VENDOR_LIST', supplier.data)
    let group = await profile.group()
      context.commit('SET_GROUP_LIST', group.data)
  },
  async fetchSerialStatus(context){
    let serialStatus = await profile.serialStatus()
      context.commit('SET_SERIAL_STATUS', serialStatus.data)
  },
  async recipe(context){
    let response = await profile.recipe()
    context.commit('SET_RECIPE_LIST', response.data)
    return response
  },
  salecode(context, data){
    return profile.salecode(data)
  },
  setImei(context, data){
    return profile.setImei(data)
  },
  barcode(context, categoryId){
    return profile.barcode(categoryId)
  },
  upload(context, { id, data}){
    return profile.upload(id, data)
  },
  saleAvailable(context, id) {
    return profile.saleAvailable(id)
  },
  calculateStock(context, id) {
    return profile.calculateStock(id)
  },
  employee(context) {
    return profile.employee()
  },
  allowChangUomCat(context, productId) {
    return profile.allowChangUomCat(productId)
  }
}